/**
 * Effects on changes within the states.
 */
export default {
    data: (state, context) => {
        const { data } = state

        /**
         * Render the filters based on the counties.
         */
        const counties = data.map(({ title, statcode }) => ({
            statcode,
            title,
        }))

        context.filter.setOptions(counties)

        /**
         * Render all county features.
         */
        data.forEach(({ feature }) => context.map.renderCountyGeoJSON(feature))

        context.map.centerOnCountyFeatures()

        /**
         * Render all municipalities in the list.
         */
        const municipalities = data
            .flatMap(({ municipalities }) => municipalities)
            .sort((a, b) => {
                if (a.title < b.title) {
                    return -1
                }
                if (a.title > b.title) {
                    return 1
                }
                return 0
            }).slice(0, 10);

        context.list.startObserving();

        context.map.addCountyLayerEvents()
        context.map.controlsActive = false

        context.list.renderItems(municipalities)
    },
    selectedCounty: (state, context) => {
        const { data, selectedCounty } = state

        /**
         * First clear the map.
         */
        context.map.clearCountyFeatures()
        context.map.clearMunicipalityFeatures()

        /**
         * Re-render the list with the preselected option.
         */
        const counties = data.map(({ title, statcode }) => ({
            statcode,
            title,
        }))

        context.filter.setOptions(counties, selectedCounty)

        if (selectedCounty === null) {
            context.map.addCountyLayerEvents()
            context.map.controlsActive = false
            data.forEach(({ feature }) =>
                context.map.renderCountyGeoJSON(feature)
            )

           /**
             * Render all municipalities in the list.
             */
            const municipalities = data
                .flatMap(({ municipalities }) => municipalities)
                .sort((a, b) => {
                    if (a.title < b.title) {
                        return -1
                    }
                    if (a.title > b.title) {
                        return 1
                    }
                    return 0
                }).slice(0, 10);


            context.list.startObserving();

            context.list.renderItems(municipalities, true)


        } else {
            /**
             * Find the selected county.
             */
            const county = data.find(
                ({ statcode }) => statcode === selectedCounty
            )

            /**
             * Render the county
             */
            context.map.removeCountyLayerEvents()
            context.map.renderCountyGeoJSON(county.feature)

            context.list.stopObserving();

            /**
             * Render the list.
             */
            const { municipalities } = county
            context.list.renderItems(municipalities, true)

            /**
             * Render the shapes on the map.
             */
            municipalities.forEach(({ feature }) =>
                context.map.renderMuniciPalityGeoJSON(feature)
            )

            context.map.controlsActive = true
        }

        /**
         * Center the map over the counties.
         */
        context.map.centerOnCountyFeatures()
    },
    highlightedCounty: (state, context) => {
        const { highlightedCounty } = state

        if (highlightedCounty !== null) {
            context.map.highlightedCountyFeature(highlightedCounty)
        } else {
            context.map.clearCountyHighlights()
        }
    },
    highlightedMunicipality: (state, context) => {
        const { highlightedMunicipality } = state

        if (highlightedMunicipality !== null) {
            context.list.selectItem(highlightedMunicipality)
            context.map.highlightedMunicipalityFeature(highlightedMunicipality)
        } else {
            context.list.deselectItems()
            context.map.clearMunicipalityHighlights()
        }
    },
    query: (state, context) => {
        const { data, query } = state
        const lowerCasedQuery = query.toLowerCase()

        const municipalities = data
            .flatMap(({ municipalities }) => municipalities)
            .filter(({ title }) =>
                title.toLowerCase().includes(lowerCasedQuery)
            )
            .sort((a, b) => {
                if (a.title < b.title) {
                    return -1
                }
                if (a.title > b.title) {
                    return 1
                }
                return 0
            })

        context.list.stopObserving();

        context.list.renderItems(municipalities, true)
    },
    offset: (state, context) => {
        const { data, offset } = state

        const perPage = 10;

        /**
         * Render all municipalities in the list.
         */
        const municipalities = data
            .flatMap(({ municipalities }) => municipalities)
            .sort((a, b) => {
                if (a.title < b.title) {
                    return -1
                }
                if (a.title > b.title) {
                    return 1
                }
                return 0
            });

        const municipalitiesCount       = municipalities.length;
        const municipalitiesRequired    = (offset + 1) * perPage;
        const municipalitiesRemaining   = (municipalitiesCount - municipalitiesRequired);

        if ( municipalitiesRemaining <= 0 ) {
            context.list.stopObserving();
            return;
        }

        const municipalitiesChunk = municipalities.slice(offset * perPage, municipalitiesRequired);

        context.list.renderItems(municipalitiesChunk)
    },
}



// WEBPACK FOOTER //
// ./scripts/web-components/municipality-picker/effects.js